<!-- 任务点排名 -->
<template>
  <div style="width: calc(100% - 8px)">
    <a-row :gutter="[16, 16]">
      <a-col class="gutter-row" :span="12">
        <version-diagram ref="diagramPie" :filter-form="filterForm" />
      </a-col>
      <a-col class="gutter-row" :span="12">
        <version-dev-complete ref="devPie" :filter-form="filterForm" />
      </a-col>
      <a-col class="gutter-row" :span="12">
        <version-test-complete ref="testPie" :filter-form="filterForm" />
      </a-col>
      <a-col class="gutter-row" :span="12">
        <a-card title="迭代任务走势" size="small">
          <div id="version-task" :style="{ height: '250px', width: '95%' }" />
        </a-card>
      </a-col>
      <a-col class="gutter-row" :span="12">
        <a-card title="迭代需求走势" size="small">
          <div id="version-req" :style="{ height: '250px', width: '95%' }" />
        </a-card>
      </a-col>
      <a-col class="gutter-row" :span="12">
        <a-card title="迭代每团队缺陷" size="small">
          <div id="version-bug" :style="{ height: '250px', width: '95%' }" />
        </a-card>
      </a-col>
    </a-row>
    <a-modal :visible="modalVisible" :closable="false" :width="800" @cancel="closeModal">
      <a-table :columns="columns" :data-source="tableData" :width="700">
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.title">
            <a class="custom-link" :href="issueLink(record)" target="_blank">{{ record.title }}</a>
          </a-tooltip>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>
<script>
import { getDailyStatus, getDailyReq, getDailyBug } from '@/api/data/task';

import VersionDiagram from '@/pages/data/diagram/components/VersionDiagram';
import VersionDevComplete from '@/pages/data/diagram/components/VersionDevCompleteChart';
import VersionTestComplete from '@/pages/data/diagram/components/VersionTestCompleteChart';

export default {
  components: { VersionDiagram, VersionDevComplete, VersionTestComplete },
  props: {
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      modalVisible: false,
      tableData: [],
      detail: {},
      selectedBug: {}, // 添加该属性
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '缺陷名称',
          dataIndex: 'title',
          key: 'title',
          scopedSlots: { customRender: 'title' }
        },
        {
          title: '处理人',
          dataIndex: 'handler',
          key: 'handler',
          width: 120,
          scopedSlots: { customRender: 'handler' }
        }
      ],
      taskOption: {
        tooltip: {
          trigger: 'axis'
        },
        legend: { data: ['全部任务', '开发完成', '已上线'] },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      },
      reqOption: {
        tooltip: {
          trigger: 'axis'
        },
        legend: { data: ['全部需求', '开发完成', '已上线'] },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      },
      bugOption: {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      }
    };
  },
  computed: {
    issueLink() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          params: { project_id: record.project_id },
          query: { issueId: record.id }
        }).href;
      };
    }
  },
  watch: {
    filterForm() {
      this.getData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/legend');
    require('echarts/lib/chart/bar');
    require('echarts/lib/chart/line');
    require('echarts/lib/component/markLine');
    this.myChartTask = echarts.init(document.getElementById('version-task'));
    this.myChartReq = echarts.init(document.getElementById('version-req'));
    this.myChartBug = echarts.init(document.getElementById('version-bug'));
    this.myChartBug.on('click', params => {
      const dataIndex = params.name; // 获取点击的柱状图索引
      const selectedResult = this.detail[dataIndex]; // 根据索引获取对应的缺陷详情数据
      this.selectedBug = selectedResult; // 更新 selectedBug 值
      this.tableData = selectedResult;
      this.modalVisible = true;
    });
    this.getData();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChartTask.resize();
      this.myChartReq.resize();
      this.myChartBug.resize();
    });
  },
  methods: {
    closeModal() {
      this.modalVisible = false;
    },
    drawChart() {
      this.myChartTask.setOption(this.taskOption, true);
      this.myChartReq.setOption(this.reqOption, true);
      this.myChartBug.setOption(this.bugOption, true);
      this.$nextTick(() => {
        this.myChartTask.resize();
      });
      this.$nextTick(() => {
        this.myChartReq.resize();
      });
      this.$nextTick(() => {
        this.myChartBug.resize();
      });
    },

    getData() {
      this.loading = true;

      this.$nextTick(() => {
        // this.$refs.diagramPie.getDiagramData();
        // this.$refs.devPie.getDiagramData();
        // this.$refs.testPie.getDiagramData();
      });

      getDailyStatus(this.filterForm)
        .then(res => {
          this.taskOption.xAxis[0].data = res.data.date_range;
          this.taskOption.series = [];
          const total = [];
          const over_dev = [];
          const online = [];
          for (const [_, array] of Object.entries(res.data.total)) {
            const length = array.length;
            total.push(length);
          }
          this.taskOption.series.push({
            name: '全部任务',
            type: 'line',
            data: total
          });
          for (const [_, array] of Object.entries(res.data.over_dev)) {
            const length = array.length;
            over_dev.push(length);
          }
          this.taskOption.series.push({
            name: '开发完成',
            type: 'line',
            data: over_dev
          });
          for (const [_, array] of Object.entries(res.data.online)) {
            const length = array.length;
            online.push(length);
          }
          this.taskOption.series.push({
            name: '已上线',
            type: 'line',
            data: online
          });
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
      getDailyReq(this.filterForm)
        .then(res => {
          this.reqOption.xAxis[0].data = res.data.date_range;
          this.reqOption.series = [];
          const total = [];
          const over_dev = [];
          const online = [];
          for (var date in res.data.date_range) {
            if (res.data.total[res.data.date_range[date]]) {
              total.push(res.data.total[res.data.date_range[date]].length);
            } else {
              total.push(0);
            }
            if (res.data.over_dev[res.data.date_range[date]]) {
              over_dev.push(res.data.over_dev[res.data.date_range[date]].length);
            } else {
              over_dev.push(0);
            }
            if (res.data.online[res.data.date_range[date]]) {
              online.push(res.data.online[res.data.date_range[date]].length);
            } else {
              online.push(0);
            }
          }
          this.reqOption.series.push({
            name: '全部需求',
            type: 'line',
            data: total
          });
          this.reqOption.series.push({
            name: '开发完成',
            type: 'line',
            data: over_dev
          });
          this.reqOption.series.push({
            name: '已上线',
            type: 'line',
            data: online
          });
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
      getDailyBug(this.filterForm)
        .then(res => {
          this.bugOption.xAxis[0].data = res.data.teams;
          this.bugOption.series = [];
          const bug_list = [];
          this.detail = res.data.result;
          for (var index in res.data.result) {
            bug_list.push(res.data.result[index].length);
          }
          this.bugOption.series.push({
            data: bug_list,
            type: 'bar',
            label: {
              show: true
            }
          });
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    },

    close() {
      this.detailVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
